<template>
  <div class="tile is-child notification box">
    <p class="subtitle"><Gavel />&nbsp;{{ count }}</p>
    <router-link
      :to="{ name: 'admin-users', query: { type: 'judge' } }"
      class="widget-action"
    >
      Judges<span>&nbsp;<Settings /></span>
    </router-link>
  </div>
</template>

<script>
import Gavel from 'vue-material-design-icons/Gavel.vue'
import Settings from 'vue-material-design-icons/Settings.vue'

export default {
  name: 'JudgeWidget',
  components: {
    Gavel,
    Settings
  },
  data () {
    return {
      count: 0
    }
  },
  mounted () {
    this.$store
      .dispatch('users/GET_USERS', {
        query: {
          type: 'judge'
        }
      })
      .then(res => {
        this.count = res.data.users.length
      })
  }
}
</script>
